<template id="AdminSlider">

	<div class="pantalla">
		<div class="row">
			<h3>Administrador de imágenes del Carrusel</h3>

			<h5 style="margin-top: 24px">Agregar Imágenes</h5>
            <hr class="red" style="margin-bottom: 0">

			<form id="formCarga" class="form-horizontal col-md-12" role="form">

				<!-- modal para la carga -->
                <loading :active.sync="isLoading"
                         color="#9D2449" background-color="#CCCCCC" />

				<div class="form-group" style="margin-left: 100px">

					<label style="margin: 20px 0px;">Selecciona la imagen:</label>
					
					<div class="inputfile-box">
						<input type="file" id="file" ref="file" class="inputfile" v-on:change="validaSeleccion(this)"/>
						<label for="file" class="file-label">
							<span id="file-name" class="file-box"></span>
							<span class="file-button">
								Examinar
							</span>
						</label>
					</div>

					<p style="margin-top: 20px; font-size: 11px; font-weight: bold;">
						Recuerda que: 
						<u style="text-decoration: none; font-weight: normal;">
							<li>Las imágenes deben ser en formato PNG o JPG/JPGE</li>
							<li>El tamaño no debe de exceder de los 500 KB </li>
							<li>El nombre de la imagen no debe ser mayor a 100 caracteres </li>
							<li>Las medidas de la imagen serán de 1140px X 400px (de lo contrario la imagen se distorcionara)</li>
						</u>
					</p>

					<div class="text-center" style="margin-top: 40px">
						
						<button type="button" class="btn btn-danger" style="margin: 5px" v-on:click="limpiaImagen()">Limpiar</button>
						<button type="button" class="btn btn-primary" style="margin: 5px" v-on:click="guardaImagen()">Subir</button>

					</div>

					
				</div>

			</form>

		</div>


		<div class="row" style="padding-bottom: 50px;">
					
			<h5>Eliminar, Habilitar/Deshabilitar imágenes cargadas</h5>
			<hr class="red" style="margin-bottom: 15px">

			<form id="formEdicion" class="form-horizontal col-md-12" role="form">

				<!-- modal para la carga -->
                <loading :active.sync="isLoading"
                         color="#9D2449" background-color="#CCCCCC" />

				<table class="table table-striped table-responsive">
					<thead>
						<tr>
							<th class="text-center">Nombre</th>
							<th class="text-center">Vista Previa</th>
							<th class="text-center">Mostrar</th>
							<th class="text-center">Eliminar</th>
						</tr>
					</thead>
					<tbody v-if="imagenes != ''">
						<tr v-for="imge in imagenes" v-bind:key="imge.idCarrusel">
							<td class="text-center">
								{{imge.nombreImg}}
							</td>
							<td class="text-center">
								<img :src="imge.imagenBase64" width="200px;" height="100px;"/>
							</td>
							<td class="text-center">
								<input type="checkbox" v-model="imge.habilitado" v-on:change="habilitaDesahilitaDeLaLista(imge)">
								<span style="font-size: 14px; margin-left: 8px;">{{imge.estatusImg == 'H' ? ' Habilitado' : ' Deshabilitado'}}</span>
							</td>
							<td class="text-center" >
								<a v-on:click="eliminaImagenDeLaLista(imge)">
									<span class="glyphicon glyphicon-trash" aria-hidden="true"/>
								</a>
							</td>
						</tr>
					</tbody>
					<tbody v-else>
						<tr><td colspan="3">No existen imágenes cargadas para el carrusel</td></tr>
					</tbody>
				</table>

				<div class="text-center" style="margin-top: 40px">
					
					<button type="button" class="btn btn-danger" style="margin: 5px" v-on:click="cancelaCambiosImagenes()">Cancelar</button>
					<button type="button" class="btn btn-primary" style="margin: 5px" data-toggle="modal" data-target="#modalValida">Guardar</button>

				</div>

			</form>

		</div>

		<!-- MODAL DE VALIDACIÓN DE LA ACTUALIZACIÓN -->
		<div class="modal fade" id="modalValida" tabindex="-1" role="dialog" aria-labelledby="modalAvisoLabel">
			<div class="modal-dialog modal-lg" style="width: 540px">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">Está solicitando guardar los cambios. ¿Desea continuar?</h4>
					</div>
				</div>
				<div class="modal-body text-justify" style="background-color: white">
					<p>Las imágenes eliminadas no podrán ser recuperadas.</p>
				</div>
				<div class="modal-footer" style="background-color: white">
					<button type="button" class="btn btn-danger" data-dismiss="modal" >Cancelar</button>
					<button type="button" class="btn btn-primary" data-dismiss="modal" @click="actualizaListaImagenes()" >Aceptar</button>
				</div>
			</div>
		</div>

	</div>

</template>

<style scoped>

	a {
		color: #9D2449;
	}

	a:hover {
		color: #b38e5d;
	}

	input[type=checkbox] {
		/* Double-sized Checkboxes */
		-ms-transform: scale(1.5); /* IE */
		-moz-transform: scale(1.5); /* FF */
		-webkit-transform: scale(1.5); /* Safari and Chrome */
		-o-transform: scale(1.5); /* Opera */
		transform: scale(1.5);
		padding: 10px;
	}

	.checkboxtext {
		/* Checkbox text */
		display: inline;
	}

</style>

<script>

	import axios from 'axios';
	import Vue from 'vue';

	export default {
		name: "AdminSlider",
		data() {
			return {
				isLoading: false,
				file: '',
				imagenes: [],
				ultimaImagen: false
			}
		},
		mounted() {

			this.isLoading = true;
			this.obtenImagenesCarrusel();
		},
		methods: {
			obtenImagenesCarrusel() {

				axios.post(Vue.prototype.$globalHost + '/consultaImagenesCarrusel',
				{}, {
					headers: {
						'Content-Type': 'application/json',
						'authorization': localStorage.getItem('token')
					}
				}).then(response => {
					
					this.imagenes = response.data;
					this.isLoading = false;
				})
				.catch(error => {

					this.isLoading = false;
					
					this.procesarErrorYdesplegarMensaje(error,
                    'Ocurrió un error en la búsqueda de imágenes precargadas')
				})
			},
			validaSeleccion() {

				const validaFile = this.$refs.file.files[0];

				if (validaFile.size > 500000) {

					this.llamarAlertaWarining('Excede el peso permitido, sólo se permiten subir imágenes de hasta 500kb.');
					this.$refs.file.value = null;
					this.file = '';
					document.getElementById("file-name").innerHTML = '';
					return;
				}

				if (validaFile.type != "image/png" && validaFile.type != "image/jpeg") {

					this.llamarAlertaWarining('El formato no es el permitido, sólo se permite subir imágenes con extensión .png, .jpg o .jpeg.');
					this.$refs.file.value = null;
					this.file = '';
					document.getElementById("file-name").innerHTML = '';
					return;
				}

				if ((validaFile.type == "image/png" && validaFile.name.length > 104)
				||  (validaFile.type == "image/jpeg" && validaFile.name.length > 105)) {
					
					this.llamarAlertaWarining('Supera el número de caracteres permitidos, el nombre de la imagen no debe ser mayor a 100 caracteres.');
					this.$refs.file.value = null;
					this.file = '';
					document.getElementById("file-name").innerHTML = '';
					return;
				}

				this.file = this.$refs.file.files[0];
				document.getElementById("file-name").innerHTML = validaFile.name;
			},
			guardaImagen() {

				this.isLoading = true;

				//Validamos que se haya seleccionado la imagen
				if(this.file == null || this.file == '' || this.file == undefined) {
					
					this.isLoading = false;
					this.llamarAlertaWarining('Aún no ha seleccionado ninguna imagen para subir.');

					return;
				}

				//Validamos que no exceda de 5 el número de imágenes
				if (this.imagenes.length == 5) {

					this.isLoading = false;
					this.llamarAlertaWarining('Ya cuenta con el número máximo de imágenes permitidas (5), debe eliminar alguna imagen del listado, para que el sistema permita subir una nueva.')

					return;
				}

				//Iniciamos con el proceso de guardar imágenes
				let formData = new FormData();
				formData.append('file', this.file);
				formData.append('param', new Blob([JSON.stringify({idEmpleadoLogueado: localStorage.getItem('user_id')})],{type:"application/json"}));

				axios.post(Vue.prototype.$globalHost + '/guardaImagenCarrusel',
					formData,
					{
					headers: {
						'Content-Type': 'multipart/form-data',
						'authorization': localStorage.getItem('token')
					}
				}).then(response => {

					console.log(response.data);
					this.$refs.file.value = null;
					this.file = '';
					document.getElementById("file-name").innerHTML = '';

					this.obtenImagenesCarrusel();

					window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
				})
				.catch(error => {

					this.isLoading = false;

					this.procesarErrorYdesplegarMensaje(error,
                    'Ocurrió un error al guardar la imagen')
                })
			},
			limpiaImagen() {

				this.$refs.file.value = null;
				this.file = '';
				document.getElementById("file-name").innerHTML = '';
			},
			cancelaCambiosImagenes() {

				this.isLoading = true;
				this.ultimaImagen = false;
				this.obtenImagenesCarrusel();
				window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
			},
			eliminaImagenDeLaLista(elemento) {

				this.imagenes.splice(this.imagenes.indexOf(elemento), 1);

				if (this.imagenes.length == 0) {
					this.ultimaImagen = true;
				}

				window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
			},
			habilitaDesahilitaDeLaLista(elemento) {

				if(elemento.habilitado) {
					elemento.estatusImg = 'H';
				} else {
					elemento.estatusImg = 'D'
				}
			},
			actualizaListaImagenes() {

				this.isLoading = true;

				//Validamos que existan imagenes a modificar
				if (this.imagenes.length == 0 && !this.ultimaImagen) {

					this.isLoading = false;
					this.llamarAlertaWarining('No existen imágenes cargadas aun.');

					return;
				}

				//Se lanza la petición
				axios.post(Vue.prototype.$globalHost + '/actualizaListaDeImagenes',
				{
					imagenes : this.imagenes,
					idEmpleadoLogueado: localStorage.getItem('user_id')
				}, {
					headers: {
						'Content-Type': 'application/json',
						'authorization': localStorage.getItem('token')
					}
				}).then(response => {

					this.imagenes = response.data;
					this.isLoading = false;
					this.ultimaImagen = false;
				})
				.catch(error => {

					this.isLoading = false;

					this.procesarErrorYdesplegarMensaje(error,
                    'Ocurrió un error al intentar editar la lista de imágenes')
				})
			}
		}
	}

</script>